"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Prefixer2 = require("./Prefixer");

var _Prefixer3 = _interopRequireDefault(_Prefixer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @author Bruno bruno.camargos@gmail.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @date 2016/01/15
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var AsciiPrefixer = function (_Prefixer) {
    _inherits(AsciiPrefixer, _Prefixer);

    function AsciiPrefixer(nDigits) {
        _classCallCheck(this, AsciiPrefixer);

        var _this = _possibleConstructorReturn(this, (AsciiPrefixer.__proto__ || Object.getPrototypeOf(AsciiPrefixer)).call(this, nDigits));

        _this.nDigits = nDigits;
        return _this;
    }

    _createClass(AsciiPrefixer, [{
        key: "encodeLength",
        value: function encodeLength(length, b) {
            var n = length;
            for (var i = this.nDigits - 1; i >= 0; i--) {
                b[i] = (n % 10).toString().charCodeAt(0);
                n /= 10;
            }
            if (parseInt(n, 10) != 0) {
                throw Error("invalid len " + length + ". Prefixing digits = " + this.nDigits);
            }
        }
    }, {
        key: "decodeLength",
        value: function decodeLength(b, offset) {
            var len = '';
            for (var i = 0; i < this.nDigits; i++) {
                len += String.fromCharCode(b[offset + i]);
            }
            return parseInt(len);
        }
    }, {
        key: "getPackedLength",
        value: function getPackedLength() {
            return this.nDigits;
        }
    }]);

    return AsciiPrefixer;
}(_Prefixer3.default);

AsciiPrefixer.LL = new AsciiPrefixer(2);
AsciiPrefixer.LLL = new AsciiPrefixer(3);
AsciiPrefixer.LLLLLL = new AsciiPrefixer(6);
exports.default = AsciiPrefixer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jspos/lib/AsciiPrefixer.js
// module id = 5
// module chunks = 0